<template>
  <div class="login-container">
    <el-card class="login-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span>用户登录</span>
      </div>
      <el-form :model="loginForm" :rules="rules" ref="loginFormRef" label-width="80px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input 
            type="password" 
            v-model="loginForm.password" 
            placeholder="请输入密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm">登录</el-button>
          <el-button @click="resetForm">重置</el-button>
          <el-button type="text" @click="goToRegister">注册</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm() {
      this.$refs.loginFormRef.validate((valid) => {
        if (valid) {
          // 调用API进行登录
          this.$axios.post('/user/login', this.loginForm).then(res => {
            if (res.code === 200) {
              const user = res.data
              // 再次检查用户状态（双重保障）
              if (user.status !== 1) {
                this.$message.error('该账号已被禁用，无法登录，请联系管理员')
                return
              }
              this.$store.dispatch('login', {
                username: user.username,
                token: 'mock-token-123456', // 暂时使用模拟token
                userInfo: user // 传入完整的用户信息
              })
              // Store full user info in localStorage for booking
              localStorage.setItem('user', JSON.stringify(user))
              this.$message.success({ message: '登录成功', duration: 1500 })
              this.$router.push('/')
            } else {
              // 根据错误信息给出更明确的提示
              if (res.message && res.message.includes('禁用')) {
                this.$message.error('该账号已被禁用，无法登录，请联系管理员')
              } else if (res.message) {
                this.$message.error(res.message)
              } else {
                this.$message.error('用户名或密码错误，或该账号已被禁用')
              }
            }
          }).catch(error => {
            console.error('Login error:', error)
            this.$message.error('登录失败，请检查网络连接')
          })
        } else {
          return false
        }
      })
    },
    resetForm() {
      this.$refs.loginFormRef.resetFields()
    },
    goToRegister() {
      this.$router.push('/register')
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 600px;
  padding: 20px;
}

.login-card {
  width: 400px;
}
</style>